import Sidebar from "./Sidebar";
import AdminNotificationBell from "./AdminNotificationBell";
import "./Layout.css";

export default function Layout({ children }) {
  return (
    <div className="layout">
      <Sidebar />
      <AdminNotificationBell />
      <div className="main-content">
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
}
